"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsInnerVariantsInnerToJSON = exports.ProductsInnerVariantsInnerFromJSONTyped = exports.ProductsInnerVariantsInnerFromJSON = exports.instanceOfProductsInnerVariantsInner = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ProductsInnerVariantsInner interface.
 */
function instanceOfProductsInnerVariantsInner(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfProductsInnerVariantsInner = instanceOfProductsInnerVariantsInner;
function ProductsInnerVariantsInnerFromJSON(json) {
    return ProductsInnerVariantsInnerFromJSONTyped(json, false);
}
exports.ProductsInnerVariantsInnerFromJSON = ProductsInnerVariantsInnerFromJSON;
function ProductsInnerVariantsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'colorId': !(0, runtime_1.exists)(json, 'color_id') ? undefined : json['color_id'],
        'enabled': !(0, runtime_1.exists)(json, 'enabled') ? undefined : json['enabled'],
        'primaryImageUrl': !(0, runtime_1.exists)(json, 'primary_image_url') ? undefined : json['primary_image_url'],
    };
}
exports.ProductsInnerVariantsInnerFromJSONTyped = ProductsInnerVariantsInnerFromJSONTyped;
function ProductsInnerVariantsInnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'color_id': value.colorId,
        'enabled': value.enabled,
        'primary_image_url': value.primaryImageUrl,
    };
}
exports.ProductsInnerVariantsInnerToJSON = ProductsInnerVariantsInnerToJSON;
